export const usePaginator = (
    entriesPerPage: MaybeRefOrGetter<Readonly<number>> = 9,
    queryParam: MaybeRefOrGetter<Readonly<string>> = 'page',
) => {
    const route = useRoute();
    const queryParamV = toValue(queryParam);
    const routePage = route?.query?.[queryParamV];
    const routePageV = getSingle(routePage);
    const currentPage = ref(parseInt(routePageV ?? '1', 10));

    const offset = computed(() => (currentPage.value - 1) * toValue(entriesPerPage));
    const limit = computed(() => toValue(entriesPerPage));

    return {
        currentPage,
        queryParam: ref(queryParam),
        offset,
        limit
    };
};

